// components/AboutSection.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';

function AboutSectionAMZ() {
  const [activeTab, setActiveTab] = useState('headquarters');

  const tabs = {
    headquarters: {
      icon: '/images/Asset5.png',
      title: 'ⴳ ⵓⵙⵇⵇⵉⵎ',
      description: 'ⵜⵉⵏⴰⵡⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ ⴷⴷⴰⵡ ⵏ ⵜⵎⴰⵜⴰⵔⵜ "ⵜⵉⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ - ⴰⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ',
      link: '/conference'
    },
    conference: {
      icon: '/images/Asset5.png',
      title: 'ⵜⵉⵏⴰⵡⵜ',
      description: 'ⵜⵉⵏⴰⵡⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ ⴷⴷⴰⵡ ⵏ ⵜⵎⴰⵜⴰⵔⵜ "ⵜⵉⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ - ⴰⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ", ⵙ ⵜⴷⵔⴰⵡⵜ ⵏ ⵜⵎⵔⵙⴰⵍ ⴷ ⵢⵉⴳⵔⴰⵏ ⴷ ⵉⵎⵙⴽⴰⵔⵏ ⴷ ⵉⵎⵓⵣⴰⵢⵏ, ⵉⵎⵖⵔⵉⴱⵉⵢⵏ, ⵉⴼⵔⵉⵇⵉⵢⵏ, ⵉⴳⵔⴰⵖⵍⴰⵏⵏ ⴷ ⵉⵏⵎⵜⵜⴰⵏⵏ',
      link: '/conference'
    },
    show: {
      icon: '/images/Asset6.png',
      title: 'ⴰⴼⵙⴰⵔ ⵏ ⵜⵉⴼⴰⵡⵜ - Mapping',
      description: 'ⵓⵟⵟⵓⵏⵏ, ⵜⵓⵣⵉⵏⵉⵏ, ⵉⵡⵏⵏⵉⵜⵏ ⴷ ⵜⴼⵉⵍⵉⵏ : ⵉⴼⵙⴰⵔⵏ ⵏ ⵜⵉⴼⴰⵡⵜ ⵅⴼ ⵓⴷⵎ ⴰⴷⵙⵍⴰⵏ ⵏ ⵜⵓⵚⴽⵉⵡⵜ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵉ ⵓⵙⴼⵔⴽ ⴷ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ',
      link: '/conference'
    },
    caravan: {
      icon: '/images/Asset4.png',
      title: 'ⴰⴽⴰⴱⴰⵕ ⴰⵏⴰⵎⵓⵔ',
      description: 'ⴰⴽⴰⴱⴰⵕ ⵉⵜⵜⵎⴰⵜⵜⴰⵢⵏ ⵉⵜⵜⴷⴷⵓⵏ ⵙ 12 ⵏ ⵜⵖⵔⵎⵜ ⴳ 12 ⵏ ⵜⵎⵏⴰⴹⵉⵏ ⴳ ⴰⴽⴽⵯ ⵓⵙⵙⴰⵏ ⵏ ⵓⵎⵣⵉⵣⵣⵍ ⵉ ⵓⵏⵎⵓⵇⵇⴰⵔ ⴷ ⵓⵎⵢⴰⵖ ⴷ ⵓⵙⴼⵔⴽ ⵅⴼ ⵜⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ',
      link: '/caravan'
    },
    music: {
      icon: '/images/Asset8.png',
      title: 'ⵉⴼⵙⴰⵔⵏ ⵉⵥⵓⵕⴰⵏⵏ ⵉⵣⵔⴼⴰⵏⵏ',
      description: 'ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵉⵣⵔⴼⴰⵏ: ⵉⴼⵙⴰⵔⵏ ⵉⵥⵓⵕⴰⵏⵏ ⵉⴽⵓⵢⴰⵙⵙⵏ ⴳ ⵉⵙⴰⵢⵔⴰⵔⵏ ⵉⵕⵥⵎⵏ, ⵙ ⵉⴼⵙⴰⵔⵏ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ. ⵉⵡⵏⵏⵉⵜⵏ ⴷ ⵉⵙⵏⴼⵍⵓⵍⵏ ⵏ ⵉⵄⵔⵔⵉⵎⵏ ⵏ ⵓⵡⵏⵏⵉ ⵅⴼ ⵉⵣⵔⴼⴰⵏ, ⴽⵓ ⴰⵙⵙ ⵙⴳ ⵜⵙⵔⴰⴳⵜ ⵜⵉⵙⵙ ⵚⴹⵉⵚⵜ ⵖⵔ ⵜⵉⵙⵙ ⵚⴹⵉⵚⵜ ⴷ ⵓⵣⴳⵏ ⵏ ⵜⴷⴳⴳⵯⴰⵜ',
      link: '/music'
    },
    stands: {
      icon: '/images/Asset7.png',
      title: 'ⵉⴼⵙⴰⵔⵏ',
      description: 'ⵉⴳⵎⵎⴰⴹⵏ ⴷ ⵉⴼⵙⴰⵔⵏ ⴳ ⵉⵙⴰⵢⵔⴰⵔⵏ ⵉⴳⴷⵓⴷⴰⵏⵏ ⵉⵅⴰⵜⴰⵔⵏ ⴳ ⵜⵖⵔⵎⵜ ⵏ ⵕⵕⴱⴰⵟ (3 ⵉⴼⵙⴰⵔⵏ, 3 ⵉⵙⴰⵢⵔⴰⵔⵏ ⵉⵎⵢⴰⵏⴰⵡⵏ) ⵉ ⵓⵎⵢⴰⵖ ⴷ ⵉⵎⵣⴷⴰⵖⵏ ⵏ ⵜⵎⴰⵥⵓⵏⵜ ⴷ ⵉⴷ ⵉⵜⵜⴰⵙⵏ ⵖⵓⵔⵙ ⴷ ⵉⴷ ⵉⴼⴼⵖⵏ ⵙⴳⵉⵙ ⵅⴼ ⵉⵎⵉⵣⵉⵜⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴷ ⵉⴱⵔⴷⴰⵏ ⵏ ⵡⴰⵔⴰⵢ ⵙⴳⵉⵙ ⴷ ⵓⵙⵉⵡⴹ ⵏⵏⵙ',
      link: '/stands'
    },
    closingEvent: {
      icon: '/images/Asset10.png',
      title: 'ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ',
      description: 'ⵜⴰⴼⵓⴳⵍⴰ ⵏ ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ: ⵉⵡⵏⵏⵉⵜⵏ ⵉⵥⵓⵕⴰⵏⵏ, ⵉⵙⵎⴰⴷⵏ ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ, ⴷ ⵉⵙⵙⴽⵜⴰⵢⵏ ⵙ ⵡⴰⵙⵙ ⴰⵎⴰⴹⵍⴰⵏ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵡⵉⵙ 80',
      link: '/closing-event'
    }
  };

  return (
    <section className="about-section">
      <div className="container">
        <h2 className="about-title">ⵅⴰⴼ ⵓⵎⵣⵉⵣⵣⵍ</h2>

        <div className="about-content">
          <p className="about-intro">
          ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
          </p>

          <div className="about-details">

            <div className="detail-card">
              <div className="detail-label"><img src="/images/duration.png" className="tab-icon2-img" /></div>

              <div className="detail-value" style={{ direction: 'ltr' }}>16 ⵏ ⵡⴰⵙⵙ</div>
            </div>
            <div className="detail-card">
              <div className="detail-label"><img src="/images/calandarv.png" className="tab-icon2-img" /></div>

              <div className="detail-value" style={{ direction: 'ltr' }}>  25 ⵏⵓⵡⴰⵏⴱⵉⵔ - 10 ⴷⵓⵊⴰⵏⴱⵉⵔ  </div>

            </div>
          </div>
        </div>

        <div className="tabs-container" style={{ direction: 'ltr' }}>
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === 'headquarters' ? 'active' : ''}`}
              onClick={() => setActiveTab('headquarters')}
            >
            ⴳ ⵓⵙⵇⵇⵉⵎ
            </button>
            <button
              className={`tab-button ${activeTab === 'caravan' ? 'active' : ''}`}
              onClick={() => setActiveTab('caravan')}
            >
              ⴰⴽⴰⴱⴰⵕ ⴰⵏⴰⵎⵓⵔ
            </button>
            <button
              className={`tab-button ${activeTab === 'stands' ? 'active' : ''}`}
              onClick={() => setActiveTab('stands')}
            >
              ⵉⴼⵙⴰⵔⵏ
            </button>
            <button
              className={`tab-button ${activeTab === 'closingEvent' ? 'active' : ''}`}
              onClick={() => setActiveTab('closingEvent')}
            >
            ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ
            </button>
          </div>

          <div className="tab-content">
    {activeTab === 'headquarters' ? (
      <div className="tab-double">
        <div className="tab-card">
          <img src={tabs['conference'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['conference'].title}</h3>
          <p className="tab-description">{tabs['conference'].description}</p>
          <Link to={tabs['conference'].link}>
            <button className="cta-button">ⵥⵕ ⵓⴳⴳⴰⵔ</button>
          </Link>
        </div>

        <div className="tab-card">
          <img src={tabs['show'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['show'].title}</h3>
          <p className="tab-description">{tabs['show'].description}</p>
          <Link to={tabs['show'].link}>
            <button className="cta-button">ⵥⵕ ⵓⴳⴳⴰⵔ</button>
          </Link>
        </div>
      </div>
    ) : activeTab === 'stands' ? (
      <div className="tab-double">
        <div className="tab-card">
          <img src={tabs['stands'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['stands'].title}</h3>
          <p className="tab-description">{tabs['stands'].description}</p>
          <Link to={tabs['stands'].link}>
            <button className="cta-button">ⵥⵕ ⵓⴳⴳⴰⵔ</button>
          </Link>
        </div>

        <div className="tab-card">
          <img src={tabs['music'].icon} alt="Logo" className="tab-icon-img" />
          <h3 className="tab-title">{tabs['music'].title}</h3>
          <p className="tab-description">{tabs['music'].description}</p>
          <Link to={tabs['music'].link}>
            <button className="cta-button">ⵥⵕ ⵓⴳⴳⴰⵔ</button>
          </Link>
        </div>
      </div>
    ) : (
      <>
        <img src={tabs[activeTab].icon} alt="Logo" className="tab-icon-img" />
        <h3 className="tab-title">{tabs[activeTab].title}</h3>
        <p className="tab-description">{tabs[activeTab].description}</p>
        <Link to={tabs[activeTab].link}>
          <button className="cta-button">ⵥⵕ ⵓⴳⴳⴰⵔ</button>
        </Link>
      </>
    )}
  </div>

        </div>
      </div>
    </section>
  );
}

export default AboutSectionAMZ;
